import React from 'react';
import { useLocation } from 'react-router-dom';
import Layout from '../../components/layout/AppLayout';
import Header from '../../../shared/components/layout/Header';
import CustomerList from '../CustomerList';
import { useSmartBack } from '../../../shared/navigation';

const SalesClosedWonPage = () => {
  const location = useLocation();
  const projectIDFromState = location.state?.projectID ?? null;
  const { onBack } = useSmartBack({ fallback: '/builder/sales/?view=dashboard' });

  return (
    <Layout>
      <div className="flex h-[100dvh] min-h-0 flex-col overflow-hidden">
        <div className="z-50 shrink-0">
          <Header data={{ name: 'Closed Won' }} backArrow={true} onBack={onBack} />
        </div>
        <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
          <CustomerList forcedProjectID={projectIDFromState} />
        </div>
      </div>
    </Layout>
  );
};

export default SalesClosedWonPage;
